@if (item().state === 'live') {
  <bingo-countdown-bar-team-side [item]="item()" side="left" />

  <div [class.is-live-transitioning]="transitioning()" class="countdown-bar__center">
    <img [src]="gameLiveImage" class="countdown-bar__game-live" alt="Game live">
  </div>

  <bingo-countdown-bar-team-side [item]="item()" side="right" />
} @else {
  <bingo-countdown-bar-team-side [item]="item()" side="left" />

  <div class="countdown-bar__center">
    <bingo-countdown-bar-timer [seconds]="item().remainingSeconds" />
  </div>

  <bingo-countdown-bar-team-side [item]="item()" side="right" />
}
